import { deleteOperacao } from "@spark/services/operacoes";
import React, { useCallback, useState, useEffect } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import Typography, { H3 } from '@spark/ui-components/components/Typography';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { BorderedBottomTabs, CustomNavLink, NavItem } from '@spark/ui-components/components/Tabs';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import styled from 'styled-components';
import OperacaoCadastro from '../Cadastro/index';
import GerenciarClientesOperacao from './components/GerenciarClientesOperacao';
import { notification } from '@spark/ui-components/utils/notification';

const OperacaoDetalhes = () => {
  const history = useHistory();
  const {
    id
  } = useParams();
  const [activeTab, setActiveTab] = useState('detalhes');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletando, setDeletando] = useState(false);
  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);
  const handleEditar = useCallback(() => {
    history.push(`/pages/operacoes/editar/${id}`);
  }, [history, id]);
  const handleExcluir = useCallback(() => {
    setShowDeleteModal(true);
  }, []);
  const handleConfirmDelete = useCallback(async () => {
    try {
      setDeletando(true);
      await deleteOperacao(id);
      notification.success('Operação excluída com sucesso!');
      history.goBack();
    } catch (error) {
      console.error('Erro ao excluir operação:', error); // Erro tratado automaticamente pelo interceptor global do axios
    } finally {
      setDeletando(false);
      setShowDeleteModal(false);
    }
  }, [history, id]); // Recarregar dados quando a tab de clientes for ativada

  useEffect(() => {
    if (activeTab === 'clientes') {
      console.log('Tab de clientes ativada, operacaoId:', id);
    }
  }, [activeTab, id]);
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Operações',
          path: '/pages/operacoes'
        }, {
          name: 'Detalhes'
        }]} />

          
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>
                  <H3>Detalhes da Operação</H3>
                </CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="outline-danger" onClick={handleExcluir}>
                    Excluir
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              <Row>
                <Col md={12}>
                  <BorderedBottomTabs className="mb-3">
                    <Nav variant="tabs" className="nav-tabs">
                      <NavItem>
                        <CustomNavLink active={activeTab === 'detalhes'} onClick={() => setActiveTab('detalhes')}>
                          
                          <span className="tab-text">Detalhes</span>
                        </CustomNavLink>
                      </NavItem>
                      <NavItem>
                        <CustomNavLink active={activeTab === 'clientes'} onClick={() => setActiveTab('clientes')}>
                          
                          <span className="tab-text">Clientes</span>
                        </CustomNavLink>
                      </NavItem>
                    </Nav>
                  </BorderedBottomTabs>
                </Col>
              </Row>

              {
              /* Conteúdo das Tabs */
            }
              {activeTab === 'detalhes' && <Row>
                  <Col md={12}>
                    <OperacaoCadastro disabled={true} id={id} hideHeader={true} />
                  </Col>
                </Row>}
              

              {activeTab === 'clientes' && <Row>
                  <Col md={12}>
                    <div style={{
                  padding: '20px 0'
                }}>
                      <GerenciarClientesOperacao operacaoId={id} onUpdate={() => {// Callback para atualizar dados se necessário
                  }} />
                    
                    </div>
                  </Col>
                </Row>}
              
            </CardBody>
          </Card>
        </Col>
      </Row>

      {
      /* Modal de confirmação de exclusão padrão do sistema */
    }
      <ConfirmDeleteModal show={showDeleteModal} onClose={() => setShowDeleteModal(false)} onConfirm={handleConfirmDelete} loading={deletando} />
      
    </Container>;
};

export default OperacaoDetalhes; // Estilos

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
